
<hr
	ref="divider"
	class="flow-divider"
	:size="size"
	:state="state"
	:type="type"
	:direction="direction"
	:data-resize-siblings="resizeSiblings"
	:data-active="resize"
	@mousedown="handleMouseDown"
/>
